import { render, staticRenderFns } from "./LotDayCheckboxCard.vue?vue&type=template&id=2283129d&scoped=true&"
import script from "./LotDayCheckboxCard.vue?vue&type=script&lang=js&"
export * from "./LotDayCheckboxCard.vue?vue&type=script&lang=js&"
import style0 from "./LotDayCheckboxCard.vue?vue&type=style&index=0&id=2283129d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2283129d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VIcon,VRow,VSpacer})
